import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'
import moment from 'moment'
import { getTimezoneDate } from 'utils/date'

let empty = {}
export let db = state => (state.data && state.data.db) || empty

//export let doc = (state, id) => state.data.db[id]
export let doc = (state, id) => {
	let doc = state.data.db[id]
	let buf = state.data.buffer[id]
	if (buf) {
		doc = {
			...doc
		  , ...buf
		}
	}
	return doc
}

export let bufferById = (state, id) => state.data.buffer[id]
export let edit = (state) => state.data.edit
export let routing = state => state.routing
export let login = state => state.login
export let mode = state => state.mode
export let selectedRows = (entity, state) => state.selectedRows[entity]
export let currentUser = state => state.session.userID
export let scrollTop = (state, id) => state.scrollTop && state.scrollTop[id] || 0
export let shouldScroll = (state) => state.shouldScroll || false
export let props = (state, props) => props
export let makePropSelector = name => (state, props) => props[name]
export let makeDocSelector = name => (state, props) => doc(state, props[name])
export let makeRefSelector = name => (state, id) => doc(state, doc(state, id)[name])
export let selectedProperty = (state) => state.selectedProperty || 'total'

export let currentDate = state => {
	let date = getTimezoneDate(state.time)
	return (date.getMonth()+1)+'-'+date.getDate()+'-'+date.getFullYear()
}

export let route = state => state.routing
	&& state.routing.locationBeforeTransitions
	&& state.routing.locationBeforeTransitions.pathname
	&& state.routing.locationBeforeTransitions.pathname.split("/").slice(2) || window.location.pathname.split('/').slice(2)

export let currentSort = (entity) => state => state.sort[entity] || {}

export let sort = (entity, o = {}) => createSelector(
	[currentSort(entity)]
  , (currentSort) => {
		if (typeof(o) == 'function') o = o(currentSort)
		let {secondary, secondaryDirection} = o
		let fn = R.pipe(R.values, R.sortWith([
			(currentSort.sortDirection == "ASC" ? R.ascend : R.descend)(R.prop(currentSort.sortBy))
		  , ...(secondary ? !secondaryDirection || secondaryDirection=='ASC'?[R.ascend(R.prop(secondary))]: [R.descend(R.prop(secondary))] : [])
		]))
		return {...currentSort, fn}
	}
  , entity+'.sort'
)

/*
let buffer = state => state.data.buffer

let merge = (db, buffer) => ({
	...db
  , ...R.map(change => ({
		...db[change._id]
	  , ...change
	}), buffer)
})

let merged = createSelector(
	[db, buffer]
  , (db, buffer) => merge(db, buffer)
  , 'dirtyRead.merged'
)

export let dirtyRead = fn => (state, props) => {
	if (!R.isEmpty(state.data.buffer)) {
		state = {
			...state
		  , data: {
				...state.data
			  , db: merged(state)
			}
		}
	}
	return fn(state, props)
}
*/

export let dirtyRead = fn => fn



// WEBPACK FOOTER //
// ./src/selectors/common.js